import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { TextField, Button, FormControl, FormControlLabel, Checkbox } from '@material-ui/core';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    }
});

class EditCvTipoGasto extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cvTipoGasto.id ? this.props.cvTipoGasto.id : uuidv4(),
            description: this.props.cvTipoGasto.descr ? this.props.cvTipoGasto.descr : '',
            isContab: this.props.cvTipoGasto.isContab ? this.props.cvTipoGasto.isContab : false,
        };

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };


    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'description'}
                            label={'Description'}
                            placeholder={'Description'}
                            margin="normal"
                            autoFocus
                            value={this.state.description}
                            onChange={(event) => this.handleValueChange(event, 'description')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl} style={{ width: 210 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.isContab}
                                    onChange={(event) => this.handleBooleanChange(event, 'isContab')}
                                    color="primary"
                                />
                            }
                            label="¿Is Contab?"
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoGasto = {
                            id: this.state.id,
                            descr: this.state.description,
                            isContab: this.state.isContab,
                        }

                        if (this.props.checkTipoGasto(tipoGasto)) {

                            this.props.okHandler(tipoGasto);
                            this.props.hideDialog();
                        }
                    }}>Guardar</Button>
                </div>
            </div>
        );
    };

};

EditCvTipoGasto.propTypes = {
    cvTipoGasto: PropTypes.object.isRequired,
    checkTipoGasto: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvTipoGasto);